import { toneVariant, useCompanionNoun } from '@/utils/personalization'
import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import type { AnswerType } from '@app-studio-web/ui/types'

const answers: AnswerType[] = [
  {
    emoji: '💬',
    title: 'pages.onboarding.goal.relationships',
    value: 'relationships',
  },
  { emoji: '🌍', title: 'pages.onboarding.goal.language', value: 'language' },
  {
    emoji: '🔥',
    title: 'pages.onboarding.goal.motivation',
    value: 'motivation',
  },
  {
    emoji: '🤝',
    title: 'pages.onboarding.goal.loneliness',
    value: 'loneliness',
  },
  { emoji: '🧠', title: 'pages.onboarding.goal.growth', value: 'growth' },
  { emoji: '😊', title: 'pages.onboarding.goal.friend', value: 'friend' },
]

export default function GoalQuestionPage() {
  const noun = useCompanionNoun()

  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.goal.title"
      subtitle={toneVariant('pages.onboarding.goal.subtitle')}
      translationInterpolation={{ noun }}
    />
  )
}
